import React, {useState} from "react";
import {ButtonGroup, ToggleButton} from "react-bootstrap";
import StorageService from "../../services/StorageService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEraser, faFilter} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/esm/Button";

const PaginationTableFilterToggle = (props) => {
    const [hasCachedConfig, setHasCachedConfig] = useState(StorageService.hasTableConfig(props.tableId));
    const [toggleButton, setToggleButton] = useState(1);
    return (
        <ButtonGroup toggle style={{float: "right", marginRight: "-12px"}}>
            {props.showFilters && hasCachedConfig ? (<Button
                onClick={() => {
                    StorageService.clearTableConfigs(props.tableId);
                    setHasCachedConfig(false);
                    setToggleButton(1);
                    props.onFilterToggle({
                        currentTarget: {
                            checked: false
                        }
                    });
                    StorageService.setTableConfigValue(
                        props.tableId,
                        "showFilters",
                        false
                    );
                }}
                className="btn-red btn-sm">
                <FontAwesomeIcon icon={faEraser} />
            </Button>) : ""}
            <ToggleButton
                type="checkbox"
                value={toggleButton}
                className={props.showFilters ? "btn-black btn-sm" : "btn-green btn-sm"}
                checked={props.showFilters}
                onChange={(e) => {
                    props.onFilterToggle(e);
                    StorageService.setTableConfigValue(
                        props.tableId,
                        "showFilters",
                        e.currentTarget.checked
                    );
                }}
            >
                <FontAwesomeIcon icon={faFilter}/>
            </ToggleButton>
        </ButtonGroup>
    );
}

export default PaginationTableFilterToggle;